import * as React from "react";
import Table from "react-bootstrap/Table";
import { Pagination } from "src/components/Pagination";
import { trpc } from "src/trpc";
import { Header } from "src/components/Header";
import { Menu, Item, useContextMenu } from "react-contexify";
import { RuleForm, Props as RuleFormProps } from "./RuleForm";
import { Page } from "src/components/Page";
import { v4 as uuid } from "uuid";
import { TableActions } from "src/components/TableActions";
import { FormControl } from "react-bootstrap";
import { Play, Plus } from "lucide-react";

const MENU_ID = `rules`;

function createEmptyRule() {
  return {
    id: uuid(),
    match: "",
    label: null,
    categoryId: null,
  };
}

export function Rules() {
  const { show } = useContextMenu<{ ruleId: string }>({ id: MENU_ID });
  const [search, setSearch] = React.useState("");
  const [page, setPage] = React.useState(1);
  const [editRule, setEditRule] = React.useState<RuleFormProps["rule"] | null>(null);
  const { data } = trpc.getRules.useQuery({ search, page });
  const { mutateAsync: deleteRule } = trpc.deleteRule.useMutation();
  const { mutateAsync: runAllRules } = trpc.runAllRules.useMutation();
  const utils = trpc.useUtils();

  const onDeleteRule = async (ruleId: string) => {
    await deleteRule({ ruleId });
    await utils.getRules.invalidate();
  };

  const onRunAllRules = async () => {
    await runAllRules();
    await utils.getTransactions.invalidate();
  };

  const { results = [], pageCount = 0 } = data ?? {};

  return (
    <Page>
      <Header title="Rules">
        <Header.Button secondary onClick={onRunAllRules} icon={Play}>
          Run Rules
        </Header.Button>
        <Header.Button onClick={() => setEditRule(createEmptyRule())} icon={Plus}>
          New Rule
        </Header.Button>
      </Header>
      <TableActions>
        <TableActions.Filters>
          <TableActions.Filter>
            <FormControl size="sm" value={search} onChange={(e) => setSearch(e.target.value)} />
          </TableActions.Filter>
        </TableActions.Filters>
        <Pagination page={page} setPage={setPage} pageCount={pageCount} />
      </TableActions>
      <Table striped bordered>
        <thead>
          <tr>
            <th>Match</th>
            <th>Label</th>
            <th>Category</th>
          </tr>
        </thead>
        <tbody>
          {results.map((r) => (
            <tr
              key={r.id}
              onClick={() => setEditRule(r)}
              onContextMenu={(event) => show({ event, props: { ruleId: r.id } })}
            >
              <td>{r.match}</td>
              <td>{r.label}</td>
              <td>{r.category?.name}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination page={page} setPage={setPage} pageCount={pageCount} />
      {editRule && <RuleForm rule={editRule} onClose={() => setEditRule(null)} />}

      <Menu id={MENU_ID}>
        <Item onClick={(e) => onDeleteRule(e.props?.ruleId)}>Delete</Item>
      </Menu>
    </Page>
  );
}
